/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Options_TitleInputs */



/**
* | output |
* | --- |
* | "Event Group Options" |
*
* @param {Event_Group_Options_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_options_title = /** @type {((inputs?: Event_Group_Options_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Options_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Options du groupe d'événements")
	if (locale === "de") return /** @type {LocalizedString} */ ("Optionen für Veranstaltungsgruppen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Opzioni gruppo evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Параметры группы событий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Opciones de grupo de eventos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("事件组选项")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントグループオプション")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट समूह विकल्प")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Opções de grupo de eventos")
	return /** @type {LocalizedString} */ ("Event Group Options")
});